<template>
  <transition name="modal">
    <div class="modal-mask" style="display: block">
      <div class="modal-dialog modal modal-special" role="document">
        <div class="modal__content modal__content--lg">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">
              Crear Corte - <app-title-custom />
            </h2>
          </div>
          <form @submit.prevent="createElement" enctype="multipart/form-data">
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-12 sm:col-span-12">
                <label>Nombre</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-model="email.name"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Numero de pieza(s)</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="email.number"
                  required
                >
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="num in nums" :value="num">
                    {{ num }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Urgente</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="email.urgent"
                  required
                >
                  <option value="" selected disabled>Seleccione...</option>
                  <option value="0">NO</option>
                  <option value="1">SI</option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Fecha de entrega</label>
                <input
                  type="date"
                  class="input w-full border mt-2 flex-1"
                  v-model="email.date"
                  required
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Proyecto</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="email.project_id"
                  required
                >
                  <option value="" disabled>Seleccione...</option>
                  <option
                    v-for="project in filteredProjects"
                    :value="project.id"
                  >
                    {{ project.name }} - {{ project.account.name }}
                    {{ project.account.country.prefix }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Campaña</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="email.campaign_id"
                  required
                >
                  <option value="" disabled>Seleccione...</option>
                  <option
                    v-for="campaign in filteredCampaigns"
                    :value="campaign.id"
                  >
                    {{ campaign.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-12 sm:col-span-12">
                <label>Url Archivo (Opcional)</label>
                <input
                  type="text"
                  class="input w-full border mt-2 flex-1"
                  v-model="email.path"
                  required
                />
              </div>
              <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                <div class="rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1">
                  <b>Nota:</b> Recuerda compartir la carpeta o archivo a las personas involucradas.
                </div>
              </div>
            </div>
            <div class="px-5 py-3 text-right border-t border-gray-200">
              <button
                type="button"
                @click="$emit('closeModal')"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="button bg-theme-1 text-white"
                :disabled="emailButtonLoading"
              >
                <template v-if="emailButtonLoading">
                  Creando Corte...
                </template>
                <template v-else> Crear Corte </template>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  props: ['nums', 'user', 'email', 'options', 'email_validated'],
  components: {
    MultiSelect,
    AppTitleCustom: TitleCustom,
  },
  created() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = null
  },
  async beforeMount() {
    await Promise.all([this.getList('campaign'), this.getList('project')])
  },
  data() {
    return {
      emailButtonLoading: false,
    }
  },
  methods: {
    ...mapActions(['getList', 'store']),
    addTag(tag) {
      this.$emit('addTag', tag)
    },
    createElement() {
      this.emailButtonLoading = true
      var vm = this
      window.$('#create').button('loading')
      vm.email.created_by = this.user.id
      vm.urgent = vm.urgent == 0 ? false : true
      vm.store(vm.email)
        .then((item) => {
          this.$emit('emailCreated')
          window.location.reload()
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          this.emailButtonLoading = false
        })
    },
  },
  computed: {
    filteredCampaigns() {
      return this.campaigns.filter((campaign) => {
        return campaign.project_id == this.email.project_id
      })
    },
    filteredProjects() {
      return this.projects.filter((campaign) => {
        return campaign.account_id == localStorage.session_account
      })
    },
    ...mapGetters({
      projects: 'getProjects',
      campaigns: 'getCampaigns',
    }),
  },
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-special {
  overflow: auto;

  background-image: initial;
  background-color: initial;

  margin-top: initial;
  margin-left: initial;
  background: none;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;

  visibility: visible;

  padding-top: 4rem;
}

.modal-special .modal__content {
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// CreateEmailModal.vue?afe6dbdc